import { useQuery } from '@tanstack/react-query';
// Service
import { getAlllocales } from './localeService';

/**
 * @description useQuery Hook to get all locales.
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * {data: Locale[], default: string}, Error>}
 */
export const useGetAllLocalesQuery = (options) => useQuery({
  queryKey: ['locales'],
  queryFn: () => getAlllocales(),
  ...options,
});
